import { Col, Input, Row } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Enums from 'utils/EnumsManager';
import { DashboardSettings_Slot } from 'views';
import { resetReports } from 'store/metaData/reports/actions';
import Actions from '../components/Actions';
import DropZone from '../components/DropZone';
import DragWrapper from '../components/DragWrapper';
import {
  resetDetails,
  setDashboardName,
  tryFetchDashboardDetailsById
} from '../flow/actions';
import styles from '../index.less';

const { DASHBOARD_MAX_SLOTS } = Enums.REPORTS;
const cx = classNames.bind(styles);

const defaultProps = {
  title: ''
};
const propTypes = {
  title: PropTypes.string,
  slots: PropTypes.array.isRequired
};

class DashboardSettings_Details extends Component {
  componentDidMount() {
    const { resetDetails, tryFetchDashboardDetailsById, match } = this.props;
    const { dashboardId } = match.params;
    if (Number(dashboardId) === -1) {
      return resetDetails();
    }
    return tryFetchDashboardDetailsById(dashboardId);
  }

  componentWillUnmount() {
    this.props.resetDetails();
    this.props.resetReports();
  }

  handleChange = e => this.props.setDashboardName(e.target.value);

  render() {
    const { slots, title } = this.props;
    return (
      <div>
        <FormattedMessage
          tagName="h2"
          id="page.DashboardSettings_Details.title"
        />
        <Input
          className="full-width mb-lg mt-sm"
          value={title}
          onChange={this.handleChange}
          size="large"
        />
        <Actions />
        {slots.length >= DASHBOARD_MAX_SLOTS && (
          <FormattedMessage
            id="page.DashboardSettings_Details.maxSlotsReached"
            values={{
              num: DASHBOARD_MAX_SLOTS
            }}
          >
            {txt => <div className={cx('maxTip')}>{txt}</div>}
          </FormattedMessage>
        )}
        <Row gutter={8}>
          <Col sm={12}>
            <DropZone x={0}>
              {slots
                .filter(s => s.position.x === 0)
                .map(s => (
                  <DragWrapper key={s.id} slotId={s.id}>
                    <DashboardSettings_Slot slotId={s.id} />
                  </DragWrapper>
                ))}
            </DropZone>
          </Col>
          <Col sm={12}>
            <DropZone x={1}>
              {slots
                .filter(s => s.position.x === 1)
                .map(s => (
                  <DragWrapper key={s.id} slotId={s.id}>
                    <DashboardSettings_Slot slotId={s.id} />
                  </DragWrapper>
                ))}
            </DropZone>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = ({ dashboardSettings }) => ({
  slots: dashboardSettings.details.slots,
  title: dashboardSettings.details.title
});
const mapDispatchToProps = {
  resetDetails,
  setDashboardName,
  tryFetchDashboardDetailsById,
  resetReports
};
DashboardSettings_Details.defaultProps = defaultProps;
DashboardSettings_Details.propTypes = propTypes;
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DashboardSettings_Details)
);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Details/container/index.jsx